import { isNative } from './platform';

// WKWebView ignores target="_blank" — links silently do nothing on iOS.
// Use @capacitor/browser (SFSafariViewController) so taps actually open the page.
export async function openExternal(url) {
  if (isNative()) {
    try {
      const { Browser } = await import('@capacitor/browser');
      await Browser.open({ url, presentationStyle: 'popover' });
      return;
    } catch (e) {
      // fall through to window.open
    }
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}

export function externalLinkProps(url) {
  return {
    href: url,
    target: '_blank',
    rel: 'noopener noreferrer',
    onClick: (e) => {
      if (isNative()) {
        e.preventDefault();
        openExternal(url);
      }
    },
  };
}
